import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './reducer/snackbarSlice';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import permissionReducers from './reducer/permissionSlice';
import sortingReducer from "./reducer/sortingSlice";
import tableSearchReducer from "./reducer/tableSearchSlice"; 
import showFiltersReducer from "./reducer/showFiltersSlice";
import LanguageReducer from "./reducer/languageSlice";
import projectLocationReducer from "./reducer/projectLocationSlice";
import refreshReducer from "./reducer/refreshSlice";

const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        permission: permissionReducers,
        sorting: sortingReducer,
        tableSearch: tableSearchReducer,
        showFilters: showFiltersReducer,
        language: LanguageReducer,
        location: projectLocationReducer,
        refresh: refreshReducer,
    }
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;